import React from 'react';
import {AuthContext} from './useAuth'
import {authProvider} from "./auth";
import {RequestResult} from "../../common/api/requestResult";
import {UserSessionData} from "../../app/userSessionData";

export function AuthProvider({children}: { children: React.ReactNode }) {
    const token=UserSessionData.getInstance().getToken();
    let userValue=null;
    if(token){
        userValue=UserSessionData.getInstance().getUser();
    }
    let [user, setUser] = React.useState<any>(userValue);

    let externalUserLogin = (userInfo:any):RequestResult => {
        const res= authProvider.externalUserLogin(userInfo);
        if(res.result) {
            setUser(res.value);
        }
        return res;
    };

    let signout = (callback: VoidFunction) => {
        authProvider.signout(() => {
            setUser(null);
            callback();
        });
    };

    let value = {user, externalUserLogin, signout};
    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}